import { render, staticRenderFns } from "./home.vue?vue&type=template&id=ba8bff48&scoped=true&lang=pug&"
import script from "./home.vue?vue&type=script&lang=js&"
export * from "./home.vue?vue&type=script&lang=js&"
import style0 from "./home.vue?vue&type=style&index=0&id=ba8bff48&prod&lang=sass&scoped=true&"
import style1 from "./home.vue?vue&type=style&index=1&id=ba8bff48&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba8bff48",
  null
  
)

export default component.exports